// Translate a route path into a friendly "build step" label.
const PATH_LABELS: Array<{ match: RegExp; label: string; step?: string }> = [
  { match: /^\/dashboard\/?$/, label: "الرئيسية", step: "تصفح" },
  { match: /^\/dashboard\/staff/, label: "الموظفون", step: "بناء فريق العمل" },
  { match: /^\/dashboard\/classes/, label: "الفصول", step: "إعداد الفصول" },
  { match: /^\/dashboard\/children/, label: "الأطفال", step: "إضافة الأطفال" },
  { match: /^\/dashboard\/parents/, label: "أولياء الأمور", step: "ربط أولياء الأمور" },
  { match: /^\/dashboard\/lessons/, label: "الدروس", step: "محتوى تعليمي" },
  { match: /^\/dashboard\/lesson\//, label: "تفاصيل درس", step: "تحرير درس" },
  { match: /^\/dashboard\/assignments/, label: "الواجبات", step: "إدارة الواجبات" },
  { match: /^\/dashboard\/exam\//, label: "امتحان", step: "امتحانات" },
  { match: /^\/dashboard\/attendance/, label: "الحضور", step: "تسجيل الحضور" },
  { match: /^\/dashboard\/billing/, label: "الفواتير", step: "الفوترة" },
  { match: /^\/dashboard\/subscription/, label: "الاشتراك", step: "إدارة الاشتراك" },
  { match: /^\/dashboard\/settings/, label: "الإعدادات", step: "ضبط الحضانة" },
  { match: /^\/dashboard\/reports/, label: "التقارير" },
  { match: /^\/dashboard\/observations/, label: "ملاحظات الأطفال" },
  { match: /^\/dashboard\/activities/, label: "الأنشطة" },
  { match: /^\/dashboard\/live-sessions/, label: "البث المباشر" },
  { match: /^\/dashboard\/parent-home/, label: "ولي الأمر — الرئيسية" },
  { match: /^\/dashboard\/student\//, label: "بوابة الطالب" },
  { match: /^\/dashboard/, label: "لوحة الحضانة" },
  { match: /^\/admin/, label: "لوحة المشرف" },
  { match: /^\/accountant/, label: "لوحة المحاسب" },
  { match: /^\/support-panel/, label: "لوحة الدعم" },
  { match: /^\/auth/, label: "تسجيل الدخول" },
  { match: /^\/install/, label: "تثبيت التطبيق" },
  { match: /^\/$/, label: "الصفحة الرئيسية" },
];

export const labelForPath = (path: string | null | undefined): { label: string; step?: string } => {
  if (!path) return { label: "—" };
  const cleaned = path.split("?")[0];
  for (const { match, label, step } of PATH_LABELS) {
    if (match.test(cleaned)) return { label, step };
  }
  return { label: cleaned };
};

export const formatDuration = (seconds: number): string => {
  if (!seconds || seconds < 0) return "0 ث";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h) return `${h}س ${m}د`;
  if (m) return `${m}د ${s}ث`;
  return `${s}ث`;
};

export const timeAgo = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (diff < 60) return `منذ ${diff} ث`;
  if (diff < 3600) return `منذ ${Math.floor(diff / 60)} د`;
  if (diff < 86400) return `منذ ${Math.floor(diff / 3600)} س`;
  return `منذ ${Math.floor(diff / 86400)} يوم`;
};

export const isOnline = (lastSeen: string | null | undefined): boolean => {
  if (!lastSeen) return false;
  return Date.now() - new Date(lastSeen).getTime() < 2 * 60 * 1000;
};

export const buildWhatsAppLink = (phone: string | null | undefined, message: string): string | null => {
  if (!phone) return null;
  const cleaned = phone.replace(/[^\d]/g, "");
  if (!cleaned) return null;
  return `https://wa.me/${cleaned}?text=${encodeURIComponent(message)}`;
};
